// @ts-ignore
/* eslint-disable */
import { request } from '@umijs/max';

/** 获取当前的用户 GET /api/admin/current */
export async function currentUser(options?: { [key: string]: any }) {
  return request<API.ApiResponse<API.CurrentUser>>('/api/admin/current', {
    method: 'GET',
    ...(options || {}),
  });
}

/** 退出登录接口 POST /api/admin/logout */
export async function outLogin(options?: { [key: string]: any }) {
  return request<API.ApiResponse<any>>('/api/admin/logout', {
    method: 'POST',
    ...(options || {}),
  });
}

/** 登录接口 POST /api/admin/login */
export async function login(body: API.LoginParams, options?: { [key: string]: any }) {
  return request<API.ApiResponse<API.LoginResult>>('/api/admin/login', {
    method: 'POST',
    headers: {
      'Content-Type': 'application/json',
    },
    data: body,
    ...(options || {}),
  });
}
